import { defineMessages } from 'react-intl';

export default defineMessages({
    coverages: {
        id: 'ml.gateway.common.quotesticky.coverages',
        defaultMessage: 'Coverages'
    },
    ercRental: {
        id: 'ml.gateway.common.quotesticky.ercRental',
        defaultMessage: 'Your estimated replacement cost for the contents is {ercVal}'
    },
    ercNonRental: {
        id: 'ml.gateway.common.quotesticky.ercNonRental',
        defaultMessage: 'Your estimated replacement cost for the dwelling is {ercVal}.'
    },
    helpCondo: {
        id: 'ml.gateway.common.quotesticky.helpCondo',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your Condo unit with materials of like, kind and quality.  These estimates are based upon information given to us from a professional construction valuating service.  Many items attached as part of your condo unit may be your insurance responsibility as per the Condo Association By-Laws.  Some Associations require unit owners to pay for interior construction materials such as drywall, paint, cabinetry, countertops and interior doors.  It is important that you understand these requirements.  If you are required to pay for such items, then you may need to increase your Replacement Cost coverage.  This is the estimated amount needed to rebuild your unit if the association requires you to provide coverage.'
    },
    helpHome: {
        id: 'ml.gateway.common.quotesticky.helpHome',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair, replace or rebuild your home with materials of like, kind and quality.  These estimates are based upon information given to us from a professional construction valuating service.  This is our recommended amount necessary to rebuild your home, however, you can choose to change the amount of coverage for comparison.  Your mortgage company may require you to maintain a specific level of replacement cost coverage on your policy.'
    },
    helpRenter: {
        id: 'ml.gateway.common.quotesticky.helpRenter',
        defaultMessage: 'Estimated Replacement cost is the estimated amount of money it would take to repair or replace your personal property with items of like, kind and quality. This amount can be changed to reflect the amount of coverage that you need.'
    },
    premium: {
        id: 'ml.gateway.common.quotesticky.premium',
        defaultMessage: 'PREMIUM:'
    }
});